<form 
  [formGroup]="dateRangePickerForm" 
  novalidate
  ivClickOutSideDirective
  (clickoutside)="onClickedOutside($event)">
  
  <div class="show-selected-dates" *ngIf="startDate && endDate">
    <span>{{ startDate | date: 'dd/MM/yyyy' }}</span>
    <span class="range-separator">-</span>
    <span>{{ endDate | date: 'dd/MM/yyyy' }}</span>
  </div>
  
  <div fxLayout="row" class="date-range">
    <div [ngClass]="openPicker ? 'date-range-filter' : 'remove-date-range-filter'" *ngIf="openPicker">
      <div class="fab-popout">
        <div class="fab-popout__container">
          <div class="formfields-padding">
            <div class="btn-tabs">
              <button 
                mat-button 
                *ngFor="let tab of tabs" 
                class="btn btn--fl btn--subtab"
                [class.active]="tab === filterBy" 
                (click)="onFilterChanged(tab)">
                <span>{{ tab }}</span>
              </button>
            </div>
            <div class="datepicker-container">
              <mat-form-field>
                <label><span i18n>Date Range</span></label>  
                <mat-date-range-input [rangePicker]="picker" disabled="true" [dateFilter]="dateFilterFn">
                  <input matStartDate formControlName="startDate" (dateChange)="onSelectionChanged('start')">
                  <input matEndDate formControlName="endDate" (dateChange)="onSelectionChanged('end')">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <mat-icon>date_range</mat-icon>
                </mat-datepicker-toggle>
                <mat-date-range-picker #picker [disabled]="disableToggleButton" (closed)="onDatePickerClosed()">
                </mat-date-range-picker>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="date-icons">
      <mat-icon class="close-icon" [ngClass]="{'hide-button': !displayClearButton}" (click)="clearDateRange()">cancel</mat-icon>
      <span class="icon-calendar" (click)="toggleClass()"></span>
    </div>
  </div>
</form>